import { v4 as uuid } from 'uuid';

import { IPatient, v2, constants } from '../../..';
import { getDefaults } from './helpers/getDefaults';
import { getJobStatuses } from './helpers/getJobStatuses';

export const personJobStatusAdapter = (
    job: IPatient,
    options: { isBuddy?: boolean } = {},
): v2.PersonJobStatus[] => {
    const jobStatuses = getJobStatuses(job, options);
    const defaults = getDefaults(job);

    const result: v2.PersonJobStatus[] = jobStatuses.map(
        ({ date, status, reason, note, followUpAction, isReverse = false }) => {
            const personJob: v2.PersonJobStatus = {
                ...defaults,
                id: uuid(),
                statusDateTime: new Date(date),
                jobTypeStatusId: status,
                personJobId: constants.NOT_CAPTURED,
                jobTypeStatus: {
                    ...defaults,
                    id: constants.NOT_CAPTURED,
                    name: status,
                    key: status,
                    jobTypeId: constants.NOT_CAPTURED,
                    isDefault: false,
                    isHcpConflictual: false,
                    isPatientConflictual: false,
                },
                followUpAction,
                note,
            };

            if (reason) {
                personJob.jobStatusReasonId = reason;
                personJob.jobStatusReason = {
                    ...defaults,
                    id: constants.NOT_CAPTURED,
                    unitId: constants.NOT_CAPTURED,
                    jobTypeId: constants.NOT_CAPTURED,
                    jobTypeStatusId: constants.NOT_CAPTURED,
                    isForMultipleHcps: false,
                    requiresNote: false,
                    isReverse,
                    reason,
                };
            }

            return personJob;
        },
    );

    return result;
};
